<template>
  <el-row>
    <el-col
      :xs="14"
      :sm="7"
      :md="6"
      :lg="5"
      :xl="4"
      style="border-bottom:solid 1px #e6e6e6 "
    >
      <a href="http://www.mxdraw.com" style="color:#333">
        <h1 class="chm_logo">
          <div class="chm_logo_img">
            <el-image
              :src="logo"
              alt="logo"
              style="width: 100%; height: 100%;"
            ></el-image>
          </div>
          MxDraw 帮助
        </h1>
      </a>
    </el-col>
    <el-col :xs="10" :sm="10" :md="18" :lg="19" :xl="20">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        background-color="#323746"
        text-color="#fff"
        active-text-color="#fff"
      >
        <el-menu-item index="1" class="hidden-xs-only"
          ><a href="/">文档首页</a></el-menu-item
        >

        <el-menu-item index="4" class>
          <template v-if="userinfo.userId == 0">
            <a href="/login">工单管理</a>
          </template>

          <template v-else>
            <a href="/mywork">工单管理</a>
          </template>
        </el-menu-item>
        <el-menu-item class="chm_menu_search hidden-xs-only">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="keywords"
            :fetch-suggestions="querySearchAsync"
            placeholder="搜索关键词"
            popperClass="chm_menu_search_list"
            :debounce="300"
            :trigger-on-focus="false"
            @select="handleSelect"
          >
            <el-button slot="append" icon="el-icon-search"></el-button>

            <template slot-scope="{ item }">
              <template v-if="searchList.length > 0">
                <el-row>
                  <el-col :span="4">
                    <div
                      class="el-icon-title overflow_hidden"
                      v-html="item.title"
                    ></div>
                  </el-col>
                  <el-col :span="20" class="chm_menu_search_list_content">
                    <el-row type="flex" justify="space-between" align="middle">
                      <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item
                          class="overflow_hidden"
                          v-if="item.p_name2"
                          >{{ item.p_name2 }}</el-breadcrumb-item
                        >
                        <el-breadcrumb-item
                          class="overflow_hidden"
                          v-if="item.p_name"
                          >{{ item.p_name }}</el-breadcrumb-item
                        >
                        <el-breadcrumb-item
                          class="overflow_hidden"
                          v-if="item.name"
                          >{{ item.name }}</el-breadcrumb-item
                        >
                      </el-breadcrumb>
                      <el-tag class="overflow_hidden">MxCad云图网页版</el-tag>
                    </el-row>
                    <el-row class="chm_menu_search_list_right">
                      <span class="name" v-html="item.name"></span>
                      <span class="createTime"
                        >时间：{{ item.createTime }}</span
                      >
                    </el-row>
                  </el-col>
                </el-row>
                <!-- <el-row tag="a" ref="option" :isShow="true" :href="'/search?k='+k" target="_blank" role="option" class="chm_menu_search_list_footer" v-if="restaurants.indexOf(item)+1 === restaurants.length">
                          查询更多结果
                      </el-row> -->
              </template>

              <template v-else>
                <!-- <el-row tag="a" role="option" class="chm_menu_search_list_footer">
                              未找到要查询的内容
                      </el-row> -->
              </template>
            </template>
          </el-autocomplete>
        </el-menu-item>
      </el-menu>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      logo: require("../../assets/img/logo2.png"),
      activeIndex: "1",
      pid: 15,
      userinfo: {},
      keywords: "",
      k: "",
      searchList: []
    };
  },
  mounted: function() {
    this.get(this.pid, this.keywords);
    document.get;
  },
  methods: {
    async get(pid, keywords) {
      var that = this;
      //发送get请求
      const res = await this.$api.post("/getUserInfo");
      that.userinfo = res.data.userInfo;

      // this.msg=res.body.data;
    },

    // hrefQuery:function(){
    //   // alert(this.keywords)
    //   // return '/search?k='+this.keywords
    //   console.log(this)
    //   this.$router.push('/search?k='+this.keywords)
    // },

    handleSelect(item) {
      var that = this;
      //  console.log(item,'**************');return
      if (item.pid) {
        window.open("/MxChm?pid=" + item.pid + "&keywords=" + that.k);
      }

      //location.href = "/MxChm?pid="+item.pid+"&keywords="+that.keywords;
      //  that.get(item.id, that.keywords)
      // this.$emit('onClick',item.pid)
      //  console.log(item)
    },
    async querySearchAsync(queryString, cb) {
      var that = this;
      const { data } = await this.$api("/search?k=" + queryString);
      that.k = queryString;
      if (data.page.list.length > 0) {
        that.searchList = data.page.list;
        this.restaurants = data.page.list;
      } else {
        that.searchList = [];
        this.restaurants = [];
      }

      // cb(data.page.list);
      // var restaurants = this.restaurants;
      // var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      // console.log(data.page.list,results)
      // clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        const rootEl = document.getElementsByClassName(
          "el-autocomplete-suggestion__wrap"
        )[0];
        let text;
        if (this.restaurants.length > 0) {
          text = `<a href="/search?k=${this.k}" target="_blank" role="option" class="chm_menu_search_list_footer">
                          查询更多结果
                      </a`;
        } else {
          text = `<a href="javaScript:" role="option" class="chm_menu_search_list_footer">
                          未找到要查询的内容
                      </a`;
        }
        if (rootEl.children.length < 2) {
          const el = document.createElement("a");
          el.innerHTML = text;
          rootEl.appendChild(el);
        } else {
          const el = rootEl.getElementsByClassName(
            "chm_menu_search_list_footer"
          )[0];
          //console.log(el)
          el.innerHTML = text;
        }
        // console.log(el,'------------')
        if (data.page.list.length > 0) {
          cb(data.page.list);
        } else {
          cb([{ title: "未查询到结果", address: "未查询到结果", item: {} }]);
        }

        // cb( [{ "title": "南拳妈妈龙虾盖浇饭", "address": "普陀区金沙江路1699号鑫乐惠美食广场A13" }])
      }, 1000 * Math.random());
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleIconClick() {}
  }
};
</script>
<style>
.el-image__inner--center {
  position: static;
  -webkit-transform: none;
  transform: none;
  display: block;
}
</style>
<style scoped>
/* logo包裹容器 */
.chm_logo {
  font-weight: 600;
  font-size: 1.3rem;
  background-color: #323746;
  color: #fff;
  height: 60px;
  margin: 0;
  display: flex;
  cursor: pointer;
  align-items: center;
  /* justify-content: center; */
  float: left;
  margin-right: 20%;
  width: 220px;
}
/* logo图片样式 */
.chm_logo_img {
  width: 45px;
  display: flex;
  align-items: center;
}
.chm_logo img {
  position: unset;
  -webkit-transform: none;
  transform: none;
}
.el-menu-demo {
  background-color: #323746;
  color: #fff;
}

.chm_menu_search {
  position: relative;
  padding: 0;
  margin-left: 460px !important;
}
.chm_menu_search_list {
  top: 70px !important;
  width: 600px !important;
  left: 50% !important;
}
.overflow_hidden {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chm_menu_search_list .el-breadcrumb__item {
  height: 30px;
  max-width: 120px;
}
.chm_menu_search_list .el-breadcrumb__inner {
  color: rgb(120 120 120) !important;
  font-size: 12px;
}
.chm_menu_search_list .el-breadcrumb {
  line-height: 30px;
  margin-left: 5px;
}
.chm_menu_search_list .createTime {
  margin-left: 5px;
}
.chm_menu_search_list_content {
  font-size: 12px;
}
.chm_menu_search_list_right {
  margin-left: 5px;
}
.chm_menu_search_list_footer {
  display: flex;
  justify-content: center;
  position: relative;
  text-decoration: unset;
  font-size: 12px;
  color: #09f;
}
.chm_menu_search_list .el-icon-title {
  width: 100%;
  font-weight: bold;
}
.chm_menu_search_list .el-tag {
  line-height: 20px;
  height: 20px;
  min-width: 100px;
  text-align: center;
}
.el-autocomplete-suggestion li {
  padding: 0;
}
.el-autocomplete-suggestion li:hover {
  background-color: unset;
}
.el-autocomplete-suggestion li .el-row {
  padding: 0 5px;
}
.el-autocomplete-suggestion li .el-row:hover {
  background-color: #f5f7fa;
}
</style>
<style>
.chm_menu_search {
  position: relative;
  padding: 0;
  margin-left: 460px !important;
}
.chm_menu_search_list {
  top: 60px !important;
  width: 600px !important;
  left: 50% !important;
}
.overflow_hidden {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chm_menu_search_list .el-breadcrumb__item {
  height: 30px;
  max-width: 120px;
}
.chm_menu_search_list .el-breadcrumb__inner {
  color: rgb(120 120 120) !important;
  font-size: 12px;
}
.chm_menu_search_list .el-breadcrumb {
  line-height: 30px;
  margin-left: 5px;
}
.chm_menu_search_list .createTime {
  margin-left: 5px;
}
.chm_menu_search_list_content {
  font-size: 12px;
}
.chm_menu_search_list_right {
  margin-left: 5px;
}
.chm_menu_search_list_footer {
  display: flex;
  justify-content: center;
  position: relative;
  text-decoration: unset;
  font-size: 12px;
  color: #09f;
  line-height: 30px;
}
.chm_menu_search_list .el-icon-title {
  width: 100%;
  font-weight: bold;
}
.chm_menu_search_list .el-tag {
  line-height: 20px;
  height: 20px;
  min-width: 100px;
  text-align: center;
}
.chm_menu_search .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.chm_menu_search .el-input-group__append,
.el-input-group__prepend {
  padding: 0 3px;
}
.el-autocomplete-suggestion__wrap {
  max-height: 320px;
}
</style>



// WEBPACK FOOTER //
// src/components/MxChm/Header.vue